import React from 'react';
import { Row as BootstrapRow, RowProps } from 'react-bootstrap';

interface CustomRowProps extends RowProps {
  style?: React.CSSProperties;
  name?: string;
  'data-testid'?: boolean | string;
}

const CustomRow: React.FC<CustomRowProps> = ({
  children,
  style,
  name,
  'data-testid': dataTestId,
  ...props
}) => {
  const testId =
    typeof dataTestId === 'string'
      ? dataTestId
      : dataTestId
        ? `row-${name || props.id || 'layout'}`
        : undefined;
  return (
    <BootstrapRow
      style={{
        marginBottom: '15px',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...style,
      }}
      data-testid={testId}
      {...props}
    >
      {children}
    </BootstrapRow>
  );
};

export default CustomRow;
